import { HttpClient } from './service'
import { IPagination } from '../types/pagination'

export interface BudgetClient {
  id?: number
  name: string
  contact: string
  created_at?: string
  updated_at?: string
}

class BudgetClientsApi {
  private basePath = '/api/budget-module/settings'

  // Get all clients (non-paginated)
  async getClients(): Promise<BudgetClient[]> {
    return HttpClient.get<BudgetClient[], null>(`${this.basePath}/clients/all/`)
  }

  // Get paginated clients with search and ordering
  async getPaginatedClients(params: {
    page?: number
    page_size?: number
    search?: string
    order?: string
  }): Promise<IPagination<BudgetClient[]>> {
    const queryParams = new URLSearchParams()
    if (params.page) queryParams.append('page', params.page.toString())
    if (params.page_size) queryParams.append('page_size', params.page_size.toString())
    if (params.search) queryParams.append('search', params.search)
    if (params.order) queryParams.append('order', params.order)

    const url = queryParams.toString()
      ? `${this.basePath}/clients/?${queryParams.toString()}`
      : `${this.basePath}/clients/`

    return HttpClient.get<IPagination<BudgetClient[]>, null>(url)
  }

  // Create a new client
  async createClient(data: BudgetClient): Promise<BudgetClient> {
    return HttpClient.post<BudgetClient, BudgetClient>(`${this.basePath}/clients/`, data)
  }

  // Update an existing client
  async updateClient(id: number, data: Partial<BudgetClient>): Promise<BudgetClient> {
    return HttpClient.patch<BudgetClient, Partial<BudgetClient>>(`${this.basePath}/clients/`, id, data)
  }

  // Delete a client
  async deleteClient(id: number): Promise<void> {
    return HttpClient.delete<void, void>(`${this.basePath}/clients/`, id)
  }

  // Bulk create clients
  async bulkCreateClients(data: BudgetClient[]): Promise<BudgetClient[]> {
    return HttpClient.post<BudgetClient[], BudgetClient[]>(`${this.basePath}/clients/bulk_create/`, data)
  }

  // Bulk update clients
  async bulkUpdateClients(data: BudgetClient[]): Promise<BudgetClient[]> {
    return HttpClient.post<BudgetClient[], BudgetClient[]>(`${this.basePath}/clients/bulk_update/`, data)
  }

  // Bulk delete clients
  async bulkDeleteClients(ids: number[]): Promise<void> {
    return HttpClient.post<void, { ids: number[] }>(`${this.basePath}/clients/bulk_delete/`, { ids })
  }
}

export default new BudgetClientsApi()
